/**
 * Cross-panel selection state.
 *
 * When a user clicks an artifact in the DAG, data explorer, or any panel,
 * the selection propagates to all other panels via this shared state.
 */

import { useContext } from "react";
import { ProvenanceContext } from "../context/ProvenanceContext";

export function useSelection() {
  const ctx = useContext(ProvenanceContext);
  if (!ctx) {
    throw new Error("useSelection must be used within a ProvenanceProvider");
  }
  return {
    selectedArtifactId: ctx.selectedArtifactId,
    selectArtifact: ctx.selectArtifact,
  };
}
